import throttle from 'lodash/throttle';

document.addEventListener('DOMContentLoaded', function () {
	const quickLinksBlocks = document.querySelectorAll('.block-quick-links');

	quickLinksBlocks.forEach(function (quickLinks) {
		initQuickLinks(quickLinks);
	});

	function initQuickLinks(quickLinks) {
		// Target the actual anchor elements
		const navLinks = quickLinks.querySelectorAll(
			'.block-quick-links__link'
		);

		if (navLinks.length === 0) {
			return;
		}

		const labelBlock = quickLinks.querySelector(
			'.block-quick-links__label'
		);
		const linkWrappers = quickLinks.querySelectorAll(
			'.block-quick-links__link-wrapper'
		);
		const activeClass = 'block-quick-links--active';
		const selectedClass = 'block-quick-links__link-wrapper--selected';
		let isClickScrolling = false;

		// Create title element for mobile display
		const titleElement = document.createElement('span');
		titleElement.className = 'block-quick-links__current-title';

		// Add main header class if quick links exists
		const mainHeader = document.querySelector('.main-header');
		if (mainHeader) {
			mainHeader.classList.add('main-header--has-floater');
		}

		// Mobile dropdown toggle - make label clickable
		if (labelBlock) {
			labelBlock.style.cursor = 'pointer'; // Make it clear it's clickable

			labelBlock.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				if (window.innerWidth <= 1199) {
					// Only on mobile/tablet
					quickLinks.classList.toggle(activeClass);
				}
			});

			// Close dropdown when clicking outside
			document.addEventListener('click', function (e) {
				if (
					window.innerWidth <= 1199 &&
					!quickLinks.contains(e.target)
				) {
					quickLinks.classList.remove(activeClass);
				}
			});
		}

		// Helper function to find target element by ID or quick_link_title
		function findTargetElement(targetId) {
			// First try to find by ID
			let targetElement = document.getElementById(targetId);

			// If no element with that ID, look for blocks with matching quick_link_title
			if (!targetElement) {
				const blocks = document.querySelectorAll(
					'[data-quick_link_title]'
				);
				blocks.forEach(function (block) {
					const blockTitle = block.dataset.quick_link_title;
					// Use same sanitization as PHP's sanitize_title
					if (blockTitle) {
						const sanitizedTitle = blockTitle
							.toLowerCase()
							.replace(/\s+/g, '-')
							.replace(/[^\w\-]+/g, '')
							.replace(/\-\-+/g, '-')
							.replace(/^-+/, '')
							.replace(/-+$/, '');
						if (targetId === sanitizedTitle) {
							targetElement = block;
						}
					}
				});
			}

			return targetElement;
		}

		// Add smooth scrolling to anchor links
		navLinks.forEach(function (link) {
			link.addEventListener('click', function (e) {
				const href = this.getAttribute('href');

				// Only handle anchor links
				if (href && href.startsWith('#')) {
					e.preventDefault();

					const targetId = href.substring(1);
					const targetElement = findTargetElement(targetId);

					if (targetElement) {
						// Close mobile dropdown on selection
						if (window.innerWidth <= 1199) {
							quickLinks.classList.remove(activeClass);
						}

						// Smooth scroll to target
						const headerHeight =
							document.querySelector('.block-navigation')
								?.offsetHeight || 64;
						const navHeight = quickLinks.offsetHeight;

						// Check if target section has padding-top: 0, add 80px offset if so
						const targetStyles =
							window.getComputedStyle(targetElement);
						const targetPaddingTop = parseInt(
							targetStyles.paddingTop,
							10
						);
						const noPaddingOffset = targetPaddingTop === 0 ? 40 : 0;

						const scrollPosition =
							targetElement.offsetTop -
							headerHeight -
							navHeight -
							noPaddingOffset +
							1;

						// Set flag to prevent scroll handler from overriding
						isClickScrolling = true;

						// Update active state immediately
						updateActiveLink(href);

						window.scrollTo({
							top: scrollPosition,
							behavior: 'smooth',
						});

						// Clear flag after scroll animation completes
						setTimeout(() => {
							isClickScrolling = false;
						}, 800);
					}
				}
			});
		});

		// Function to update active link and title
		function updateActiveLink(activeHref) {
			// Remove selected class from all link wrappers
			linkWrappers.forEach(function (wrapper) {
				wrapper.classList.remove(selectedClass);
			});

			// Add selected class to current link wrapper and update title
			navLinks.forEach(function (link, index) {
				if (link.getAttribute('href') === activeHref) {
					const wrapper = linkWrappers[index];
					if (wrapper) {
						wrapper.classList.add(selectedClass);

						// Update mobile title
						updateMobileTitle(link);
					}
				}
			});
		}

		// Function to update mobile title display
		function updateMobileTitle(activeLink) {
			if (!labelBlock) return;

			// Remove existing title if present
			const existingTitle = labelBlock.querySelector(
				'.block-quick-links__current-title'
			);
			if (existingTitle) {
				existingTitle.remove();
			}

			// Add new title with just the text (no link wrapper) - show on all screen sizes
			if (activeLink) {
				const newTitle = titleElement.cloneNode();
				newTitle.textContent =
					activeLink.textContent || activeLink.innerText;
				labelBlock.appendChild(newTitle);
			}
		}

		// Throttle scroll event for better performance
		const throttledHighlight = throttle(highlightCurrentSection, 100);

		window.addEventListener('scroll', throttledHighlight, {
			passive: true,
		});

		// Function to highlight the current section based on scroll position
		function highlightCurrentSection() {
			// Skip if we're in the middle of a click-initiated scroll
			if (isClickScrolling) return;

			let currentSection = null;
			const headerHeight =
				document.querySelector('.block-navigation')?.offsetHeight || 64;
			const navHeight = quickLinks.offsetHeight;
			const scrollPosition =
				window.scrollY + headerHeight + navHeight + 10;

			navLinks.forEach(function (link) {
				const href = link.getAttribute('href');
				if (href && href.startsWith('#')) {
					const targetId = href.substring(1);
					const targetElement = findTargetElement(targetId);

					if (targetElement) {
						// Account for 40px offset on sections with no padding-top
						const targetStyles =
							window.getComputedStyle(targetElement);
						const targetPaddingTop = parseInt(
							targetStyles.paddingTop,
							10
						);
						const noPaddingOffset = targetPaddingTop === 0 ? 40 : 0;

						const sectionTop =
							targetElement.offsetTop - noPaddingOffset;
						const sectionBottom =
							sectionTop + targetElement.offsetHeight;

						if (
							scrollPosition >= sectionTop &&
							scrollPosition < sectionBottom
						) {
							currentSection = href;
						}
					}
				}
			});

			if (currentSection) {
				updateActiveLink(currentSection);
			} else if (window.scrollY < 100 && navLinks.length > 0) {
				// If no section is current, try to select the first one if at top
				const firstHref = navLinks[0].getAttribute('href');
				if (firstHref && firstHref.startsWith('#')) {
					updateActiveLink(firstHref);
				}
			}
		}

		// Handle window resize to close mobile dropdown on desktop
		let resizeTimeout;
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(function () {
				if (window.innerWidth > 1199) {
					quickLinks.classList.remove(activeClass);
				}
				// Always update highlighting on resize
				highlightCurrentSection();
			}, 250);
		});

		// Set initial active state
		if (window.location.hash) {
			updateActiveLink(window.location.hash);
		} else if (navLinks.length > 0) {
			// Set first item as active by default
			const firstHref = navLinks[0].getAttribute('href');
			if (firstHref && firstHref.startsWith('#')) {
				updateActiveLink(firstHref);
			}
		}

		// Initial highlight check after a short delay to ensure page is fully loaded
		setTimeout(function () {
			highlightCurrentSection();
		}, 100);
	}
});
